interface DashboardHeaderProps {
  title: string;
}

export function DashboardHeader({ title }: DashboardHeaderProps) {
  return (
    <header className="dashboard-header">
      <div className="header-ribbon">
        <h1>{title}</h1>
      </div>
    </header>
  );
}
